import { agenda } from "@/data/content";

export default function SampleAgenda() {
  return (
    <section id="agenda" className="py-20 md:py-28 bg-[var(--aura-ivory-2)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <span className="eyebrow">Sample Agenda</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            What an Aura event can feel like
          </h2>
          <p className="mt-5 font-body text-[var(--aura-charcoal-2)] leading-relaxed">
            A flexible, 90-minute guided format that adapts to different tracks
            and audiences.
          </p>
          <p className="mt-6 font-body text-xs text-[var(--aura-muted)] max-w-sm">
            Every Aura event is adapted to the audience, category, format,
            location, and desired outcome.
          </p>
        </div>

        <div className="lg:col-span-7">
          <ol className="relative border-l border-[var(--aura-teal)]/25 pl-6 space-y-6">
            {agenda.map((a, i) => (
              <li key={a.range} className="relative">
                <span
                  className="absolute -left-[31px] top-1.5 w-3 h-3 rounded-full bg-[var(--aura-teal)] ring-4 ring-[var(--aura-ivory-2)]"
                  aria-hidden="true"
                />
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                  <div className="font-display text-lg">{a.title}</div>
                  <div className="font-ui text-xs uppercase tracking-[0.18em] text-[var(--aura-muted)]">
                    {a.range}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
